<template>
  <v-tooltip bottom>
    <template #activator="{ on }">
      <v-btn
        :icon="!$vuetify.breakpoint.lgAndUp"
        color="primary"
        exact
        :loading="loading || (formState && formState.saving)"
        @click="onClick"
        v-on="on"
      >
        <v-icon small>mdi-floppy</v-icon>
        <span v-if="$vuetify.breakpoint.lgAndUp" class="ml-2">
          {{ label }}
        </span>
      </v-btn>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
/**
 * Save button for VaForm which runs `onSubmit` before the form is saved, for
 * work the record depends on. If `onSubmit` rejects the form is not saved, so
 * it is up to `onSubmit` to tell the user what went wrong.
 */
export default {
  inject: {
    formState: { default: null },
  },
  props: {
    onSubmit: Function,
    label: String,
    redirect: {
      type: String,
      validator: (v) => ['list', 'create', 'show', 'edit'].includes(v),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onClick() {
      this.loading = true;
      try {
        if (this.onSubmit) {
          await this.onSubmit();
        }
      } catch {
        return;
      } finally {
        this.loading = false;
      }
      this.formState.submit(this.redirect);
    },
  },
};
</script>
